import { IApplicationState } from '../../types/redux';

export const selectRealEstateType = (state: IApplicationState) => state.calculator.initialFormState.realEstateType;
